<template >
    <div>
        <b-table
            :items="items"
            :fields="fields"
        >
        <template #cell(Action)="row">
            <div>
                <b-button type="Danger" @click="deleteItem( row.item )">Удалить</b-button>
            </div>

        </template>
        </b-table>

    </div>
</template>
<script>
export default {
    props: ['items', '<tableType'],
    data() {
        return {
            fields:
            [
                {
                    key: 'name',
                    label: 'Имя',
                    sortable: true,
                    sortDesc: false
                },
                {
                    key: 'value',
                    label: 'Значение'
                },
                // {
                //     key: 'Action',
                //     label: 'Действие'
                // }
            ]
        }
    },
}
</script>
<style lang="">

</style>